import { normalizeDateInput } from '@/lib/luxon-dates'

export type MongoFilterValueType = 'auto' | 'string' | 'number' | 'boolean' | 'null' | 'objectId' | 'date'

export const MONGO_VALUE_TYPE_OPTIONS: { value: MongoFilterValueType; label: string }[] = [
  { value: 'auto', label: 'Auto' },
  { value: 'string', label: 'String' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'null', label: 'Null' },
  { value: 'objectId', label: 'ObjectId' },
  { value: 'date', label: 'Date' },
]

const VALID_VALUE_TYPES = new Set<string>(MONGO_VALUE_TYPE_OPTIONS.map(o => o.value))

export function parseMongoFilterValueType(raw: unknown): MongoFilterValueType {
  if (typeof raw === 'string' && VALID_VALUE_TYPES.has(raw)) {
    return raw as MongoFilterValueType
  }
  return 'auto'
}

export function resolveMongoValueType(
  valueType: MongoFilterValueType | undefined,
  columnType: string | undefined,
): Exclude<MongoFilterValueType, 'auto'> | 'string' {
  if (valueType && valueType !== 'auto') return valueType
  if (columnType === 'objectId') return 'objectId'
  if (columnType === 'number') return 'number'
  if (columnType === 'boolean') return 'boolean'
  if (columnType === 'date') return 'date'
  return 'string'
}

export function coerceMongoFilterValue(
  val: string,
  valueType: MongoFilterValueType | undefined,
  columnType?: string,
): unknown {
  const resolved = resolveMongoValueType(valueType, columnType)

  switch (resolved) {
    case 'null':
      return null
    case 'boolean':
      if (val === 'true') return true
      if (val === 'false') return false
      return val === '1'
    case 'number': {
      const num = Number(val)
      if (!isNaN(num) && val.trim() !== '') return num
      return val
    }
    case 'objectId':
      if (/^[0-9a-f]{24}$/i.test(val)) return { $oid: val }
      return val
    case 'date': {
      if (!val.trim()) return val
      return { $date: normalizeDateInput(val) }
    }
    case 'string':
    default:
      return val
  }
}

export function isMongoFilterExecutable(
  field: string,
  value: string,
  valueType?: MongoFilterValueType,
): boolean {
  if (!field) return false
  if (valueType === 'null') return true
  return value.trim().length > 0
}
